import { ResourceType } from "./ResourceManager"

export const adaptProjectToResource = (project: {
  id: string
  title: string
  shownProjectNumber: string
}): ResourceType => {
  return {
    id: project.id,
    name: `${project.shownProjectNumber}: ${project.title}`,
  }
}

export const adaptTaskToResource = (task: { id: string; title: string; shownTaskNumber: string }): ResourceType => {
  return {
    id: task.id,
    name: `${task.shownTaskNumber}: ${task.title}`,
  }
}
